import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Lock } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { safeNextPath } from "@/lib/auth-redirect";

/**
 * Schermata "accesso richiesto" (401): sostituisce qualsiasi shell vuota
 * quando l'utente non ha una sessione valida.
 */
export function AuthRequired({ next }: { next?: string }) {
  const { t } = useTranslation();
  const target = safeNextPath(
    next ?? (typeof window !== "undefined" ? window.location.pathname + window.location.search : undefined),
  );

  return (
    <div className="flex min-h-dvh items-center justify-center px-5 py-10">
      <Card className="w-full max-w-sm p-6 text-center">
        <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/10 text-primary">
          <Lock className="h-6 w-6" aria-hidden />
        </span>
        <h1 className="mt-4 text-lg font-semibold tracking-tight" suppressHydrationWarning>
          {t("states.authRequiredTitle")}
        </h1>
        <p className="mt-2 text-sm text-muted-foreground" suppressHydrationWarning>
          {t("states.authRequiredBody")}
        </p>
        <Button asChild className="mt-5 w-full">
          <Link to="/auth" search={target ? { next: target } : undefined}>
            <span suppressHydrationWarning>{t("states.authRequiredCta")}</span>
          </Link>
        </Button>
      </Card>
    </div>
  );
}
